import { render, staticRenderFns } from "./addNewAsset.vue?vue&type=template&id=3f9d1cba&scoped=true"
import script from "./addNewAsset.vue?vue&type=script&lang=js"
export * from "./addNewAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d1cba",
  null
  
)

export default component.exports